// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"a90ff42a","118":"c1635c62","137":"647c6c3a","457":"206fa901","535":"eeeb2090","854":"8ab3e4a4","915":"e9925031","948":"66c30a19","951":"553d1ce5"}[chunkId] + ".chunk.js";
};